<template>
  <div class="no-customer-badge" :style="badgeStyle">
    <dd-icon icon="mdi mdi-email color-grey-less-transparent" :size="size"/>
  </div>
</template>

<script>
import Spacings from "~/new_design_components/enums/Spacings";

export default {
  name: "EmailBadge.vue",
  props: {
    size: {
      required: false,
      type: String,
      default: 'xxl',
      validator(value) {
        return Object.keys(Spacings).includes(value);
      }
    },
  },
  computed: {
    badgeStyle() {
      return {
        width: (Spacings[this.size] * 1.45) + 'px !important',
        height: (Spacings[this.size] * 1.45) + 'px !important',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.no-customer-badge{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px $color-grey-less-transparent solid;
}
</style>